import {
  fetchOrdersPortfolioTool,
  fetchSegmentMemberCountsTool,
  fetchTeamUtilizationTool,
  listTeamLeadersTool,
} from './aggregations'
import { createSegmentTool } from './filter/create_segment'
import { findMatchingSegmentTool } from './filter/find_matching_segment'
import { saveFilterTool } from './filter/save_filter'
import { saveFilterToSegmentTool } from './filter/save_filter_to_segment'
import type { AiChatBotTool } from '@/Atomic/Widgets/AiChatBot/core/engine/types'
import { buildFilterTool } from '@/Atomic/Widgets/AiChatBot/core/tools/primitives/filter/build_filter'
import { showFilterPreviewTool } from '@/Atomic/Widgets/AiChatBot/core/tools/primitives/filter/show_filter_preview'

// Cast: defineTool<T> returns AiChatBotTool<T>; array requires AiChatBotTool<unknown>.
// The contravariance is safe because tool-system validates args via schema.parse before
// passing them to run(). One cast here replaces per-tool casts at every call site.

export const AGGREGATION_TOOLS: AiChatBotTool<unknown>[] = [
  listTeamLeadersTool,
  fetchTeamUtilizationTool,
  fetchOrdersPortfolioTool,
  fetchSegmentMemberCountsTool,
] as AiChatBotTool<unknown>[]

export const FILTER_TOOLS: AiChatBotTool<unknown>[] = [
  buildFilterTool,
  showFilterPreviewTool,
  saveFilterTool,
  saveFilterToSegmentTool,
  findMatchingSegmentTool,
  createSegmentTool,
] as AiChatBotTool<unknown>[]
